import { ReweighError } from '@shared/classes/error/reweigh-error';

export class IllegalStateError extends ReweighError {
  constructor(aMessage: string, aCause?: any) {
    super(aMessage, aCause);
  }
}
